import React, {Fragment, useContext} from "react";
import {ShiftRequestManagementContext} from "../ShiftRequestManagement";
import {TableContainer, ActionButtons} from "./ShiftRequestManagementTable.styles";
import {CustomButton} from "../../_defaultComponents/CustomButton/CustomButton";
import {useTranslation} from "react-i18next";
import {Tooltip} from "antd";
import moment from "moment";
import {EmptyMessage} from "../../_defaultComponents/EmptyMessage/EmptyMessage";

export const ShiftRequestManagementTable = () => {
    const {
        shiftRequests,
        isListLoading,
        setSelectedShiftRequest,
        setIsCreateModalOpen,
        handleChangeShiftStatusRequest
    } = useContext(ShiftRequestManagementContext);

    const {t} = useTranslation();

    return (
        <Fragment>
            <TableContainer
                rowKey="_id"
                dataSource={shiftRequests}
                data-testid="shiftTable"
                loading={isListLoading}
                scroll={{x: "max-content"}}
                locale={{
                    emptyText: <EmptyMessage />
                }}
                display={shiftRequests.length > 0 ? "grid" : "flex"}
                dataTitles={[
                    t("shiftDetails.shiftDay", {ns: "shiftRequest"}),
                    t("shiftDetails.shiftTime", {ns: "shiftRequest"}),
                    t("fields.companyName", {ns: "common"}),
                    t("shiftDetails.courierCount", {ns: "shiftRequest"}),
                    t("shiftDetails.status.title", {ns: "shiftRequest"}),
                    t("shiftDetails.shiftNote", {ns: "shiftRequest"}),
                    t("actions.action", {ns: "common"})
                ]}
            >
                <TableContainer.Column
                    dataIndex="date"
                    title={t("shiftDetails.shiftDay", {ns: "shiftRequest"})}
                    render={date => (
                        <span data-testid="date">
                            {!date ? "-" : moment(date).format("DD.MM.YYYY")}
                        </span>
                    )}
                />
                <TableContainer.Column
                    dataIndex="shiftTime"
                    title={t("shiftDetails.shiftTime", {ns: "shiftRequest"})}
                    render={(date, record) => (
                        <span>
                            {record.startTime.substring(0, record.startTime.length - 3)} -{" "}
                            {record.endTime.substring(0, record.endTime.length - 3)}
                        </span>
                    )}
                />
                <TableContainer.Column
                    dataIndex="company"
                    title={t("fields.companyName", {ns: "common"})}
                    render={(_, record) => (
                        <span data-testid="companyName">
                            {record.company.companyName} - {record.subcompany.name}
                        </span>
                    )}
                />
                <TableContainer.Column
                    dataIndex="personCount"
                    title={t("shiftDetails.courierCount", {ns: "shiftRequest"})}
                    render={personCount => <span data-testid="personCount">{personCount}</span>}
                />
                <TableContainer.Column
                    dataIndex="status"
                    title={t("shiftDetails.status.title", {ns: "shiftRequest"})}
                    render={status => (
                        <span data-testid="status">
                            {t(`shiftDetails.status.${status}`, {ns: "shiftRequest"})}
                        </span>
                    )}
                />
                <TableContainer.Column
                    dataIndex="shiftNote"
                    title={t("shiftDetails.shiftNote", {ns: "shiftRequest"})}
                    render={shiftNote => <span data-testid="shiftNote">{shiftNote}</span>}
                />
                <TableContainer.Column
                    dataIndex="actions"
                    title={t("actions.action", {ns: "common"})}
                    render={(_, record) => (
                        <ActionButtons>
                            <CustomButton
                                onClick={() => {
                                    setSelectedShiftRequest(record);
                                    setIsCreateModalOpen(true);
                                }}
                            >
                                {t("actions.update", {ns: "common"})}
                            </CustomButton>
                            {record?.status !== "approved" ? (
                                <CustomButton
                                    type="primary"
                                    onClick={() => {
                                        handleChangeShiftStatusRequest({
                                            ...record,
                                            newStatus: "approved"
                                        });
                                    }}
                                >
                                    {t("actions.activate", {ns: "common"})}
                                </CustomButton>
                            ) : (
                                <CustomButton
                                    type="danger"
                                    onClick={() => {
                                        handleChangeShiftStatusRequest({
                                            ...record,
                                            newStatus: "rejected"
                                        });
                                    }}
                                >
                                    {t("actions.inactivate", {ns: "common"})}
                                </CustomButton>
                            )}
                        </ActionButtons>
                    )}
                />
            </TableContainer>
        </Fragment>
    );
};
